<template>
  <div class="ndcmpr">
    <RtLayout
      class="ndcmpr_item z-index_4 rtcs_no-transition"
      :class="[{ rtcs_5x: mobile }]"
      :flipped="!heroLeft"
      :showLeft="true"
      :showCenter="true"
      :showRight="true"
    >
      <template #left>
        <RtTableTitle
          class="z-index_3"
          style="--rt-title-padding: 0 0 0.25rem 0; --rt-title-gap: 0"
          :flipped="heroLeft"
        >
          <template #left>
            <div
              class="weight_700 clr-grey text-nowrap f-align-center line-height_1 text-normal"
              style="gap: 0.25rem"
            ></div>
            <slot name="table_hero_title1"></slot>
          </template>
          <template #right>
            <RangeCopyBtn
              class="my-auto"
              tour="rdccopyrangebtn"
              :hasActions="true"
              :range="heroRange1"
              :flipped="heroLeft"
              :solution="solution1"
              :showBetsIn="showBetsIn"
            />
          </template>
        </RtTableTitle>
        <div class="f-column flex-1 position-relative d-flex z-index_2">
          <MessageOverlaySkeleton
            v-if="messages1"
            class="gw_mesblock_container"
            :isBlurred="true"
            :isTopDown="true"
          >
            <LoaderSpinner
              v-if="messages1.includes('loading')"
              :style="`--size:4rem`"
              style="min-height: 3.5rem"
            />
            <slot
              :name="
                messages1.includes('error')
                  ? 'error'
                  : messages1.includes('no_solution')
                    ? 'no_solution'
                    : 'none'
              "
            ></slot>
          </MessageOverlaySkeleton>
          <StudyRangeTable
            ref="table1"
            class="ndcmpr_table"
            tour="rangetable"
            player="0"
            idPrefix="hero1"
            :namespace="namespace"
            :tableGroups="tableGroups1"
            :playerGroupId="playersDetail[0].group_id"
            :playerGroupsIds="playersDetail[0].groups_ids"
            :heroGroupId="playersDetail[0].group_id"
            :setHoveredComboForHeroOnly="true"
            :viewProps="viewProps"
            :grouping="grouping"
            :useHex="useHex"
            :evProps="evProps1"
            :showBetsIn="showBetsIn"
            :bettingInfo
            :tableMouseover="tableMouseover"
            :street="street"
            :rangeKey="viewProps.rangeKey"
            :showProp="viewProps.hero_showPropTable"
            :asEmpty="false"
            :noValue="viewProps.hero_noValueTable"
            :valueProp="viewProps.hero_valuePropTable"
            :isCentered="max1280"
            @combo:click="handleComboClick"
          >
          </StudyRangeTable>
        </div>
      </template>
      <template #center>
        <div
          class="ndcmpr_center scroll-bottom-overlay f-column mh-0 flex-1"
          style="--clr-scrl-back: var(--clr-back); --scrl-height: 1.25rem"
        >
          <div
            class="gw-box f-column mw-0"
            style="gap: 0.325rem"
          >
            <div
              class="d-flex"
              style="gap: 0.25rem"
            >
              <UnSwitcherNew
                tour="ndccategoriesswitch"
                trigger="click"
                :hasText="true"
                :hasOpener="true"
                :closeOnContentClick="true"
                tstPrefix="nodecompare"
                class="w-100"
                style="
                  --uns-opener-padding: 0.5rem;
                  --uns-opener-clr-back: var(--clr-black-2);
                  --uns-btn-padding: 0 0.75rem 0 0.5rem;
                  --uns-opener-padding: 0 1.25rem 0 0.5rem;
                  --uns-opener-height: 100%;
                "
                swKey="sw_range_content_hero"
                :tab="swRangeContentHero"
                :hasNamedSelectedSlot="true"
                :hasNamedDefaultSlot="true"
                @click="item => $emit('update:swRangeContentHero', item.payload)"
                @click:threeway="item => $emit('update:swRangeContentHero', item.payload)"
              >
              </UnSwitcherNew>
              <slot name="center_top"></slot>
              <div
                class="gw_box f-center"
                style="gap: 2px; padding: 0 0.375rem; --clr-box-back: var(--clr-black-2)"
              >
                <StudyEvConverterSwitcher :hasICMConverter="!!bettingInfo.evIcmConverters[0]" />
                <StudyRangeHeightSwitcher />
                <StudyGroupingSwitcherNew />
              </div>
            </div>
          </div>
          <SolfigrNodeCompareCenter
            class="ndcmpr_center_inner no-scroll-track"
            :catDraws="catDraws"
            :catEqBuckets="catEqBuckets"
            :catEqBucketsAdvanced="catEqBucketsAdvanced"
            :catHands="catHands"
            :filterCategories="filterCategories"
            :filterCombos="filterCombos"
            :grouping="grouping"
            :hasFilterSuits="$store.getters.sw_range_content_hero !== 'swv_strategy'"
            :hasRangesComparison="$store.getters.sw_range_content_hero !== 'swv_strategy'"
            :hasStrategyComparison="$store.getters.sw_range_content_hero === 'swv_strategy'"
            :hero="hero1"
            :heroLeft="true"
            :heroSolution="solution_picked1"
            :isPreflop="isPreflop"
            :namespace="namespace"
            :players1="players1"
            :players2="players2"
            :opponent1="opponent1"
            :opponent2="opponent2"
            :opponent="hero2"
            :opponentSolution="solution_picked2"
            :showBetsIn="showBetsIn"
            :skeletonOnly="skeletonOnly"
            :useHex="useHex"
          />
        </div>
      </template>
      <template #right>
        <RtTableTitle
          :flipped="!heroLeft"
          style="--rt-title-padding: 0 0 0.25rem 0; --rt-title-gap: 0"
          class="z-index_3"
        >
          <template #left>
            <div
              class="weight_700 clr-grey line-height_1 f-align-center text-normal"
              style="gap: 0.25rem"
            ></div>
            <slot name="table_hero_title2"></slot>
          </template>
          <template #right>
            <RangeCopyBtn
              v-show="!!hero2.position"
              :hasActions="true"
              :range="heroRange1"
              :flipped="!heroLeft"
              :solution="solution1"
              :showBetsIn="showBetsIn"
            />
          </template>
        </RtTableTitle>

        <div class="f-column flex-1 position-relative d-flex z-index_2">
          <MessageOverlaySkeleton
            v-if="messages2"
            class="gw_mesblock_container"
            :isBlurred="true"
            :isTopDown="true"
          >
            <LoaderSpinner
              v-if="messages2.includes('loading')"
              :style="`--size:4rem`"
              style="min-height: 3.5rem"
            />
            <slot
              :name="
                messages2.includes('error')
                  ? 'error'
                  : messages2.includes('no_solution')
                    ? 'no_solution'
                    : messages2.includes('choose_solution')
                      ? 'choose_solution'
                      : 'none'
              "
            ></slot>
          </MessageOverlaySkeleton>
          <StudyRangeTable
            ref="table2"
            player="0"
            idPrefix="hero2"
            class="ndcmpr_table"
            :namespace="namespace"
            :tableGroups="tableGroups2"
            :playerGroupId="playersDetail[0].group_id"
            :playerGroupsIds="playersDetail[1].groups_ids"
            :heroGroupId="playersDetail[1].group_id"
            :setHoveredComboForHeroOnly="true"
            :viewProps="viewProps"
            :grouping="grouping"
            :useHex="useHex"
            :evProps="evProps2"
            :showBetsIn="showBetsIn"
            :bettingInfo
            :tableMouseover="tableMouseover"
            :street="street"
            :rangeKey="viewProps.rangeKey"
            :showProp="viewProps.hero_showPropTable"
            :asEmpty="false"
            :noValue="viewProps.hero_noValueTable"
            :valueProp="viewProps.hero_valuePropTable"
            :isCentered="max1280"
            @combo:click="handleComboClick"
          >
          </StudyRangeTable>
        </div>
      </template>
    </RtLayout>
    <GwMenu
      ref="gwmenu1"
      :isMovable="true"
      :referenceEl="referenceEl1"
      :boundary="boundary1"
      @close="resetPlayersGroups"
    >
      <StudyCombos
        data-gwmenu="noclose"
        class="gw_floating-hands large-scroll-track"
        :style="boundary1 ? `max-width: ${boundary1.offsetWidth}px` : ''"
        :street="street"
        player="0"
        :group="tableGroup1"
        :viewProps="viewProps"
        :mobile="mobile"
        :isPreflop="isPreflop"
        :grouping="grouping"
        :showBetsIn="showBetsIn"
        :evProps="evProps1"
        :bettingInfo
        :rangeKey="viewProps.rangeKey"
        :showProp="viewProps.hero_showPropTable"
        :asEmpty="false"
        :hasBlockers="false"
        :useHex="useHex"
      />
    </GwMenu>
    <GwMenu
      ref="gwmenu2"
      :isMovable="true"
      :referenceEl="referenceEl2"
      :boundary="boundary2"
    >
      <StudyCombos
        data-gwmenu="noclose"
        class="gw_floating-hands large-scroll-track"
        :style="boundary2 ? `max-width: ${boundary2.offsetWidth}px` : ''"
        :street="street"
        player="0"
        :group="tableGroup2"
        :viewProps="viewProps"
        :mobile="mobile"
        :isPreflop="isPreflop"
        :grouping="grouping"
        :bettingInfo
        :showBetsIn="showBetsIn"
        :evProps="evProps2"
        :rangeKey="viewProps.rangeKey"
        :showProp="viewProps.hero_showPropTable"
        :asEmpty="false"
        :hasBlockers="false"
        :useHex="useHex"
      />
    </GwMenu>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import StudyEvConverterSwitcher from '@/components/Switchers/StudyEvConverterSwitcher'
import StudyRangeHeightSwitcher from '@/components/Switchers/StudyRangeHeightSwitcher'
import StudyGroupingSwitcherNew from '@/components/Switchers/StudyGroupingSwitcherNew'
import { SNK } from '@/helpers/helpers'

import StudyRangeTable from '@/components/Study/StudyRangeTable'
import RangeCopyBtn from '@/components/RangeCopyBtn/RangeCopyBtn'
import RtLayout from '@/components/RangeTables/RtLayout'
import RtTableTitle from '@/components/RangeTables/RtTableTitle'
import SolfigrNodeCompareCenter from '@/components/Dialogs/Solfigr/SolfigrNodeCompareCenter'
import StudyCombos from '@/components/Study/StudyCombos'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrNodeCompareMain',
  components: {
    GwMenu,
    UnSwitcherNew,
    LoaderSpinner,
    MessageOverlaySkeleton,
    StudyEvConverterSwitcher,
    StudyRangeHeightSwitcher,
    StudyGroupingSwitcherNew,
    SolfigrNodeCompareCenter,
    RtTableTitle,
    StudyRangeTable,
    RangeCopyBtn,
    RtLayout,
    StudyCombos,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { required: true, type: String },

    swRangeContentHero: { deafult: 'swv_strategy' },

    hSpot: Object,

    messages1: { default: () => [] },
    messages2: { default: () => [] },
    players1: Array,
    players2: Array,
    opponent1: Object,
    opponent2: Object,

    hero1: Object,
    solution1: { default: () => [] },
    heroRange1: { default: () => [] },
    solution_picked1: { default: () => [] },
    evProps1: Object,
    tableGroups1: { default: () => [] },

    hero2: Object,
    solution2: { default: () => [] },
    heroRange2: { default: () => [] },
    solution_picked2: { default: () => [] },
    evProps2: Object,
    tableGroups2: { default: () => [] },

    ccProps: Object,
    viewProps: Object,

    playersDetail: { default: () => [] },
    catDraws: Array,
    catHands: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,

    heroLeft: { type: Boolean, default: true },

    filteredHeroHandsIds: { default: () => [] },
    filteredOpponentHandsIds: { default: () => [] },

    filterCombos: Object,
    filterCategories: { default: () => [] },

    skeletonOnly: Boolean,

    showBetsIn: String,
    street: String,
    isPreflop: Boolean,
    bettingInfo: Object,
    mobile: Boolean,
    max1280: Boolean,

    grouping: String,
    useHex: Boolean,
    tableMouseover: Boolean,
    hasShortcutBtn: Boolean,
  },
  emits: ['update:swRangeContentHero'],
  data() {
    return {
      canConfirm: false,

      tableGroup1: null,
      tableGroup2: null,
      referenceEl1: null,
      referenceEl2: null,
      boundary1: null,
      boundary2: null,
    }
  },
  methods: {
    handleComboClick({ event, combos, showProp, player, disabled, trigger }) {
      const heroIndex = 0
      if (this.tableGroup1?.id !== combos.id && this.$refs.table1 && this.$refs.table2) {
        this.tableGroup1 = this.tableGroups1.find(gg => gg.id === combos.id)
        this.tableGroup2 = this.tableGroups2.find(gg => gg.id === combos.id)
        this.referenceEl1 = document.getElementById(`hero1_${combos.id}`)
        this.referenceEl2 = document.getElementById(`hero2_${combos.id}`)

        if (this.tableGroup1.players[heroIndex].range && this.$refs.gwmenu1) {
          this.boundary1 = this.$refs.table1.$el
          this.$refs.gwmenu1.toggleOpen(true)
        }
        if (this.tableGroup2.players[heroIndex].range && this.$refs.gwmenu2) {
          this.boundary2 = this.$refs.table2.$el
          this.$refs.gwmenu2.toggleOpen(true)
        }
      } else {
        this.tableGroup1 = null
        this.tableGroup2 = null
        this.resetPlayersGroups()
      }
    },
    resetPlayersGroups() {
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group_id',
        value: '',
        player: '0',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ndcmpr {
  --gap: var(--laytsttd-gap, 0.5rem);
  --padding-content: var(--laytsttd-padding-content, 0.5rem);
  --clr-back: var(--clr-black-1);

  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  &_item {
    padding: var(--padding-content);
    background: var(--clr-back);
    border-radius: 6px;
    position: relative;
  }
  &_center {
    display: flex;
    flex-direction: column;
    min-width: clamp(16rem, 22rem, 19.5vw);
    padding: 2rem var(--gap) 0 var(--gap);
    &_inner {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      margin: 0.5rem 0 0 0;
      border-radius: 4px;
      padding: 0 0 3.125rem 0;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}

.slfcntr_evchart {
  --clr-text: var(--clr-white-0);
  --clr-winner: var(--clr-primary);
  --clr-loser: var(--clr-error);
  .slfcntr_arrow {
    font-size: 1.5rem;
  }
  .slfcntr_loser {
    --clr-text: var(--clr-loser);
    .slfcntr_arrow {
      transform: rotate(0deg);
    }
  }
  .slfcntr_winner {
    --clr-text: var(--clr-winner);
    .slfcntr_arrow {
      transform: rotate(180deg);
    }
  }

  gap: 1rem;
  &_legend {
    gap: 1rem;
    &_item {
      font-weight: 500;
      &::before {
        content: '';
        display: inline-block;
        width: 1rem;
        height: 1rem;
        border-radius: 4px;
        margin: 0 0.5rem 0 0;
        background: var(--clr-back);
      }
    }
  }
  &_hero {
    --clr-back: var(--clr-black-2-3);
  }
  &_opponent {
    --clr-back: var(--clr-black-4);
  }

  &_players {
    width: 100%;
    gap: 0.5rem;
    &_player {
      &_cont {
        border-radius: 4px;
        background: var(--clr-black-2);
        overflow: hidden;
      }
      background: var(--clr-back);
      height: 1.25rem;
      position: relative;
      color: var(--clr-text);
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
}

@media (max-width: 1023px) {
  .ndcmpr {
    &_center {
      padding: 1rem 0 0 0;
    }
  }
}
</style>
